const fieldWithActionEventStates = {
  update: (field, appData) => {
    const { name: fieldName, isErrorStatus, data } = field;
    const groupName = data?.groupName;

    if (groupName) {
      const fieldsArray = appData.screenValidation.fields;
      const errorFieldForGroup = fieldsArray.find(
        fieldItem => fieldItem?.data?.groupName === groupName
      );

      field.isValid = !isErrorStatus;
      field.fieldName = fieldName;
      field.groupErrorMessage = data?.groupErrorMessage || groupName;

      if (!errorFieldForGroup) {
        fieldsArray.push(field);
      }
      return field;
    }
  }
};

export default fieldWithActionEventStates;
